import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

@Component({
  selector: 'mp-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent {
  @Input() attributeList: ModelAttributeConfig[] = [];
  @Input() useCustom: boolean;
  @Input() attributeListContext: any;
  @Output() modelAttributeWasClicked = new EventEmitter();

  handleModelAttributeClicks(event) {
    this.modelAttributeWasClicked.emit(event);
  }
}
